import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Navbar: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  React.useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-friet-beige shadow-xl py-0' : 'bg-friet-beige shadow-lg py-0'}`}>
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between py-1">

          {/* Left side: logo + nav links on xl screens */}
          <div className="flex items-center">
            <Link to="/" className="flex items-center">
              <img
                src="/images/logonav.png"
                alt="FrietPlus"
                className={`w-auto transition-all duration-300 ${isScrolled ? 'h-20' : 'h-32'}`}
              />
            </Link>
            {/* Text links — only visible on xl (fullscreen), sit next to logo */}
            <ul className="hidden xl:flex items-center space-x-6 ml-8">
              <li><Link to="/over-ons" className="transition-colors font-serif font-black text-xl text-friet-red hover:text-red-700">Our story</Link></li>
              <li className="relative group">
                <button className="transition-colors flex items-center gap-1 font-serif font-black text-xl text-friet-red hover:text-red-700">
                  Menu <i className="fas fa-chevron-down text-xs"></i>
                </button>
                <div className="absolute top-full left-0 mt-2 bg-white shadow-lg rounded-lg py-2 w-48 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all border border-friet-beige">
                  <Link to="/weddings" className="block px-4 py-2 hover:bg-friet-beige text-friet-oak font-sans text-base">Menu</Link>
                  <Link to="/kids-parties" className="block px-4 py-2 hover:bg-friet-beige text-friet-oak font-sans text-base">Kinderfeestjes</Link>
                  <Link to="/corporate" className="block px-4 py-2 hover:bg-friet-beige text-friet-oak font-sans text-base">Bedrijfsevents</Link>
                </div>
              </li>
              <li><Link to="/gallery" className="transition-colors font-serif font-black text-xl text-friet-red hover:text-red-700">Gallerij</Link></li>
              <li><Link to="/real-stories" className="transition-colors font-serif font-black text-xl text-friet-red hover:text-red-700">Real Stories</Link></li>
              <li><Link to="/faq" className="transition-colors font-serif font-black text-xl text-friet-red hover:text-red-700">FAQ</Link></li>
            </ul>
          </div>

          {/* lg only (1024–1279px): all nav items on the right, original layout */}
          <ul className="hidden lg:flex xl:hidden items-center space-x-6">
            <li><Link to="/over-ons" className="transition-colors font-serif font-black text-xl text-friet-red hover:text-red-700">Our story</Link></li>
            <li className="relative group">
              <button className="transition-colors flex items-center gap-1 font-serif font-black text-xl text-friet-red hover:text-red-700">
                Menu <i className="fas fa-chevron-down text-xs"></i>
              </button>
              <div className="absolute top-full left-0 mt-2 bg-white shadow-lg rounded-lg py-2 w-48 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all border border-friet-beige">
                <Link to="/weddings" className="block px-4 py-2 hover:bg-friet-beige text-friet-oak font-sans text-base">Menu</Link>
                <Link to="/kids-parties" className="block px-4 py-2 hover:bg-friet-beige text-friet-oak font-sans text-base">Kinderfeestjes</Link>
                <Link to="/corporate" className="block px-4 py-2 hover:bg-friet-beige text-friet-oak font-sans text-base">Bedrijfsevents</Link>
              </div>
            </li>
            <li><Link to="/gallery" className="transition-colors font-serif font-black text-xl text-friet-red hover:text-red-700">Gallerij</Link></li>
            <li><Link to="/real-stories" className="transition-colors font-serif font-black text-xl text-friet-red hover:text-red-700">Real Stories</Link></li>
            <li><Link to="/faq" className="transition-colors font-serif font-black text-xl text-friet-red hover:text-red-700">FAQ</Link></li>
            <li className="flex items-center gap-2">
              <a href="mailto:info@frietplus.com" className="w-10 h-10 bg-friet-red rounded-full flex items-center justify-center hover:bg-friet-gold transition-all" aria-label="E-mail">
                <i className="fas fa-envelope text-white text-sm"></i>
              </a>
              <Link to="/private-parties#contact-formulier" className="w-10 h-10 bg-friet-red rounded-full flex items-center justify-center hover:bg-friet-gold transition-all" aria-label="Contactformulier">
                <i className="fas fa-phone text-white text-sm"></i>
              </Link>
            </li>
            <li>
              <Link to="/private-parties" className="bg-friet-red text-white px-6 py-2 rounded-full hover:bg-red-700 transition-colors">
                Vraag offerte
              </Link>
            </li>
          </ul>

          {/* xl only: icons + CTA on the far right */}
          <div className="hidden xl:flex items-center gap-2">
            <a href="mailto:info@frietplus.com" className="w-10 h-10 bg-friet-red rounded-full flex items-center justify-center hover:bg-friet-gold transition-all" aria-label="E-mail">
              <i className="fas fa-envelope text-white text-sm"></i>
            </a>
            <Link to="/private-parties#contact-formulier" className="w-10 h-10 bg-friet-red rounded-full flex items-center justify-center hover:bg-friet-gold transition-all" aria-label="Contactformulier">
              <i className="fas fa-phone text-white text-sm"></i>
            </Link>
            <Link to="/private-parties" className="bg-friet-red text-white px-6 py-2 rounded-full hover:bg-red-700 transition-colors ml-2">
              Vraag offerte
            </Link>
          </div>

          {/* Mobile Menu Toggle */}
          <button
            className="lg:hidden flex flex-col space-y-1"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <span className="w-6 h-0.5 bg-friet-black"></span>
            <span className="w-6 h-0.5 bg-friet-black"></span>
            <span className="w-6 h-0.5 bg-friet-black"></span>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="lg:hidden py-4 border-t border-friet-beige">
            <ul className="space-y-4">
              <li><Link to="/over-ons" className="block text-friet-oak hover:text-friet-red">Our story</Link></li>
              <li><Link to="/weddings" className="block text-friet-oak hover:text-friet-red">Menu</Link></li>
              <li><Link to="/kids-parties" className="block text-friet-oak hover:text-friet-red">Kinderfeestjes</Link></li>
              <li><Link to="/corporate" className="block text-friet-oak hover:text-friet-red">Bedrijfsevents</Link></li>

              <li><Link to="/gallery" className="block text-friet-oak hover:text-friet-red">Gallerij</Link></li>
              <li><Link to="/real-stories" className="block text-friet-oak hover:text-friet-red">Real Stories</Link></li>
              <li><Link to="/faq" className="block text-friet-oak hover:text-friet-red">FAQ</Link></li>
              <li className="flex items-center gap-3">
                <a href="mailto:info@frietplus.com" className="w-10 h-10 bg-friet-red rounded-full flex items-center justify-center hover:bg-friet-gold transition-all" aria-label="E-mail">
                  <i className="fas fa-envelope text-white text-sm"></i>
                </a>
                <a href="tel:+32478758023" className="w-10 h-10 bg-friet-red rounded-full flex items-center justify-center hover:bg-friet-gold transition-all" aria-label="Bellen">
                  <i className="fas fa-phone text-white text-sm"></i>
                </a>
              </li>
              <li>
                <Link to="/private-parties" className="block bg-friet-red text-white px-6 py-2 rounded-full text-center">
                  Vraag offerte
                </Link>
              </li>
            </ul>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
